import getMenuItems from './menuItems'
import locales from './locales'
import routes from './routes'
import themes from './themes'
import grants from './grants'

var fbc = {
  firebase_config_dev: {
    apiKey: "AIzaSyCJHDYdukc4i2p8ln0izvB0x-yG5sSnJaU",
    authDomain: "fleet-managment-dev.firebaseapp.com",
    databaseURL: "https://fleet-managment-dev.firebaseio.com",
    projectId: "fleet-managment-dev",
    storageBucket: "gs://fleet-managment-dev.appspot.com",
    messagingSenderId: "455642562302"
  },
  firebase_config_prod: {
    apiKey: "AIzaSyBFpS-sC_VfsgiUZwZv_w22qCQbv4lMdFU",
    authDomain: "fleet-managment-170817.firebaseapp.com",
    databaseURL: "https://fleet-managment-170817.firebaseio.com",
    projectId: "fleet-managment-170817",
    storageBucket: "gs://fleet-managment-170817.appspot.com",
    messagingSenderId: "583398931417"
  },
}

const config = {
  firebase_config:fbc.firebase_config_dev/*window.origin.indexOf('localhost:')>0
				 ||window.origin.indexOf('fleet-managment-dev:')>0? fbc.firebase_config_dev : fbc.firebase_config_prod*/,
  firebase_config_dev  : fbc.firebase_config_dev,			 
  firebase_config_prod : fbc.firebase_config_prod,			 
  firebase_providers: [
    'google.com',
/*    'facebook.com',
    'twitter.com',
    'github.com',*/
    'password'
  ],
  initial_state: {
    theme: 'dark',
    locale: 'fr'
  },
  drawer_width: 256,
  locales,
  themes,
  grants,
  routes,
  getMenuItems,
  firebaseLoad: () => import('./firebase'),
}

export default config



// WEBPACK FOOTER //
// ./src/config.js